exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vu-heart-inline[data-v-6ecb6cb0]{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:20px;height:20px;background:#1a0c14;color:#fff;border-radius:5px;font-size:12px;line-height:1;vertical-align:-4px;margin:0 3px;box-shadow:0 1px 2px rgba(0,0,0,.15)}.rose-highlight[data-v-6ecb6cb0]{background-color:var(--pink);color:#fff;padding:0 4px;border-radius:4px;-webkit-box-decoration-break:clone;box-decoration-break:clone}", ""]);

// exports
